export default __webpack_public_path__ + "img/1e779a4c319dfe5010099c47f0fe7430.png";